import React, { useState, useRef, useEffect } from "react";

const RadioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [volume, setVolume] = useState(0.5);
  const [station, setStation] = useState(
    "http://redir.atmcdn.pl/sc/o2/Eurozet/live/antyradio.livx"
  );
  const [location, setLocation] = useState(null);
  const [browserInfo, setBrowserInfo] = useState("");
  const audioRef = useRef(new Audio(station));

  // Aktualizacja głośności
  useEffect(() => {
    audioRef.current.volume = volume;
  }, [volume]);

  // Aktualizacja źródła stacji i odtwarzania
  useEffect(() => {
    audioRef.current.src = station;
    if (isPlaying) {
      audioRef.current.play().catch((err) => console.error("Błąd odtwarzania audio:", err));
    }
  }, [station, isPlaying]);

  // Aktualizacja daty i czasu
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    // Pobieranie geolokalizacji
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        setLocation({ error: "Geolokalizacja została wyłączona przez użytkownika." });
      }
    );

    // Informacje o przeglądarce
    setBrowserInfo(`${navigator.appName} - ${navigator.userAgent}`);

    return () => clearInterval(timer);
  }, []);

  // Obsługa odtwarzania/pauzy
  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch((err) => console.error("Błąd odtwarzania audio:", err));
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="radio-player">
      <h2>Odtwarzacz Radia</h2>

      {/* Wybór stacji */}
      <label>Wybierz stację: </label>
      <select value={station} onChange={(e) => setStation(e.target.value)}>
        <option value="http://redir.atmcdn.pl/sc/o2/Eurozet/live/antyradio.livx">Antyradio</option>
        <option value="https://playerservices.streamtheworld.com/api/livestream-redirect/RMF_FM.mp3">RMF FM</option>
        <option value="http://streaming.tdiradio.com:8000/house.mp3">House Radio</option>
      </select>

      {/* Przycisk odtwarzania/pauzy */}
      <button onClick={togglePlayPause}>
        {isPlaying ? "Pauza" : "Odtwórz"}
      </button>

      {/* Regulacja głośności */}
      <div>
        <label>Głośność: </label>
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={(e) => setVolume(parseFloat(e.target.value))}
        />
      </div>

      {/* Data i godzina */}
      <div className="date-time">
        <p>Data: {currentDateTime.toLocaleDateString()}</p>
        <p>Godzina: {currentDateTime.toLocaleTimeString()}</p>
      </div>

      {/* Geolokalizacja */}
      <div className="location-info">
        <h3>Geolokalizacja:</h3>
        {location ? (
          location.error ? (
            <p>{location.error}</p>
          ) : (
            <p>Szerokość: {location.latitude}, Długość: {location.longitude}</p>
          )
        ) : (
          <p>Trwa określanie lokalizacji...</p>
        )}
      </div>

      {/* Informacje o przeglądarce */}
      <div className="browser-info">
        <h3>Informacje o przeglądarce:</h3>
        <p>{browserInfo}</p>
      </div>
    </div>
  );
};

export default RadioPlayer;
